import {baseFetch} from "./axios-instance";

export const getProductsService = async (provider, params) => await baseFetch.post(`${provider}/products?${params}`);
export const getLevantaProductsService = async (params) => await baseFetch.post(`/levanta-products?${params}`);
export const getLevantaProductService = async (params) => (await baseFetch.post(`/levanta-product?${params}`)).data;
